export default __webpack_public_path__ + "static/media/badge.b7f55aa3.svg";